import { studyDescriptionOptions, validateProviderNumber } from './optionsData'

const VALIDATE_EMAIL = true
const VALIDATE_PHONE = false
const VALIDATE_PROVIDER_NUMBER = false
const SKIP_VALIDATE = false

const requiredFields = [
  'referrer.firstName',
  'referrer.lastName',
  'referrer.emailAddress',
  'referrer.phoneNumber',
  'request.firstName',
  'request.lastName',
  'request.dob',
  'request.modality',
  'request.studyDescription'
]

export const handleValidate = (values, sourceBusinessUnit) => {
  const validatePhone = /^[+]?[(]?[0-9]{2,4}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/i
  const validateEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+$/i

  const apex = sourceBusinessUnit === 'Apex Radiology (WA)'
  const required = apex
    ? requiredFields.filter(field => field !== 'request.requestingInstitution')
    : requiredFields

  const objectKeysRequired = (base, obj) =>
    Object.fromEntries(
      Object.entries(obj)
        .map(([key, val]) => {
          return !required.includes(`${base}.${key}`)
            ? [key, null]
            : [key, val ? null : 'This field is required.']
        })
        .filter(([key, val]) => val !== null)
    )

  const { referrer, requests } = values

  let referrerErrors = objectKeysRequired('referrer', referrer)

  if (VALIDATE_PHONE && !validatePhone.test(values.referrer.phoneNumber)) {
    referrerErrors.phoneNumber = 'Please enter a valid phone number.'
  }

  if (VALIDATE_EMAIL && !validateEmail.test(values.referrer.emailAddress)) {
    referrerErrors.emailAddress = 'Please enter a valid email address.'
  }

  if (
    VALIDATE_PROVIDER_NUMBER &&
    !validateProviderNumber(values.referrer.providerNumber)
  ) {
    referrerErrors.providerNumber = 'Please enter a valid provider number.'
  }

  const requestsErrors = Object.fromEntries(
    requests
      .map((request, index) => {
        let request_ = { ...request }
        if (
          studyDescriptionOptions(sourceBusinessUnit, request.modality)
            .length === 0
        ) {
          // skip validation on the study description
          // if none available for this modality
          delete request_.studyDescription
        }

        let errors = objectKeysRequired('request', request_)
        const { dob, studyDates } = request_
        const dobDate = new Date(dob)
        const now = new Date()
        const futureDateError = 'Date cannot be in the future.'
        const requiredError = 'This field is required.'
        if (dobDate > now) {
          errors.dob = futureDateError
        }
        if (!studyDates.allDates) {
          // no radio button selection
          errors.studyDates = {}
          errors.studyDates.allDates = requiredError
        } else if (studyDates.allDates === 'false') {
          const startDate = new Date(studyDates.startDate)
          const endDate = new Date(studyDates.endDate)
          if (!errors.studyDates) errors.studyDates = {}
          if (!studyDates.startDate) {
            errors.studyDates.startDate = requiredError
          }
          if (!studyDates.endDate) {
            errors.studyDates.endDate = requiredError
          }
          if (startDate > endDate) {
            errors.studyDates.startDate = 'Start date must be before end date.'
          }
          if (startDate > now) {
            errors.studyDates.startDate = futureDateError
          }
          if (endDate > now) {
            errors.studyDates.endDate = futureDateError
          }
          if (Object.keys(errors.studyDates).length === 0) {
            delete errors.studyDates
          }
        }
        if (apex) {
          if (request_.useInteleViewer === null) {
            errors.useInteleViewer = requiredError
          } else if (
            request_.useInteleViewer &&
            request_.inteleViewerUsername.trim() === ''
          ) {
            errors.inteleViewerUsername = requiredError
          }
        } else {
          if (!request.requestingInstitution) {
            errors.requestingInstitution = requiredError
          }
        }

        return [index, errors]
      })
      .filter(([index, request]) => Object.keys(request).length > 0)
  ) // index.fieldName

  const result = SKIP_VALIDATE
    ? {}
    : {
        ...(Object.keys(referrerErrors).length > 0
          ? { referrer: referrerErrors }
          : {}),
        ...(Object.keys(requestsErrors).length > 0
          ? { requests: requestsErrors }
          : {})
      }
  return result
}
